export function EmptyState({ icon: Icon, title, description, action, testId }) {
  return (
    <div className="card-arch p-10 text-center flex flex-col items-center" data-testid={testId}>
      <div className="halo" />
      {Icon && (
        <div className="relative mb-4 flex h-14 w-14 items-center justify-center rounded-2xl border border-white/10 bg-white/[0.03]">
          <Icon className="h-6 w-6 text-amber-400" />
        </div>
      )}
      <h3 className="relative font-head text-lg font-semibold text-white">{title}</h3>
      {description && <p className="relative mt-2 max-w-md text-sm text-slate-400">{description}</p>}
      {action && <div className="relative mt-5">{action}</div>}
    </div>
  );
}
